import { AirlinesClient, CountriesClient } from 'api/swagger/ApiClient';
import { VariousReportsApi } from 'api/various-reports';
import { autoinject } from "aurelia-framework";
import { FileResponse } from 'model/essential-types';

@autoinject
export class VariousReportsClientApi implements VariousReportsApi {
  constructor(private countriesClient: CountriesClient, private airlinesClient: AirlinesClient) { }

  getCountriesReport(): Promise<FileResponse> {
    return this.countriesClient.getCountriesOverviewReport();
  }

  getAirlinesReport(): Promise<FileResponse> {
    return this.airlinesClient.getAirlinesOverviewReport();
  }
}
